import { NavLink, Link } from 'react-router-dom';
import { cn } from '@/lib/cn';

const links = [
  { to: '/seller/dashboard', label: 'Today' },
  { to: '/seller/services', label: 'Services' },
  { to: '/seller/requests', label: 'Requests' },
  { to: '/seller/availability', label: 'Hours' },
  { to: '/seller/reviews', label: 'Reviews' },
  { to: '/seller/earnings', label: 'Earnings' },
];

/**
 * Secondary navigation for the seller "Studio". The bottom bar only exposes the
 * dashboard, so without this a seller can't reach their services, availability,
 * reviews or earnings. Render it at the top of every seller management page.
 */
export function SellerSubNav() {
  return (
    <div className="mx-auto max-w-3xl px-6 pt-6">
      <div className="flex items-center justify-between gap-4">
        <nav
          aria-label="Studio"
          className="-mx-1 flex gap-1 overflow-x-auto scrollbar-hide"
        >
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/seller/dashboard'}
              className={({ isActive }) =>
                cn(
                  'shrink-0 rounded-full px-4 py-1.5 text-[11px] uppercase tracking-widest transition-colors',
                  isActive
                    ? 'bg-makhe-ink text-makhe-bg'
                    : 'text-makhe-muted hover:text-makhe-ink',
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Link
          to="/seller/services/new"
          className="shrink-0 rounded-full bg-makhe-brand px-4 py-1.5 text-[11px] uppercase tracking-widest text-makhe-on"
        >
          + New
        </Link>
      </div>
    </div>
  );
}
